export const endpoints = {
  getR2DOrders: "/v2/orders",
  updateOrderMetaInfo: (orderId: string) => `/v1/orders/${orderId}/meta-info`,
  applyHopDestination: (orderId: string) =>
    `/v1/orders/${orderId}/logistics-path/destination`,
  garaazTransition: (orderId: string) =>
    `/v1/orders/${orderId}/garaaz_transition`,

  getShipments: "/v1/shipments",
  createShipment: "/v1/shipments",
  updateShipment: (shipmentId: string) => `/v1/shipments/${shipmentId}`,
  deleteShipment: (shipmentId: string) => `/v1/shipments/${shipmentId}`,
  cancelShipment: (shipmentId: string) => `/v1/shipments/${shipmentId}/cancel`,

  getMediaById: (id: string) => `/media/${id}`,

  mobileConfig: "/mobile/config",
  getGrazeons: "/v1/grazeons",
  mergeInvoices: "/media/merge",
  getSupplierById: (supplierId: string) => `/v1/suppliers/${supplierId}`,
  getSuppliersV2: "/v2/suppliers?isPopulated=true",
};

export const porterEndpoints = {
  getPorterQuote: "/v1/porter/quote",
  bookPorter: "/v1/porter/book",
  trackShipment: (shipmentId: string) =>
    `/v1/porter/shipments/${shipmentId}/track`,
  cancelShipment: (shipmentId: string) =>
    `/v1/porter/shipments/${shipmentId}/cancel`,
};
